export default {
  CHANGE_MEDIA: 'changeMedia',
  WINDOW_RESIZE: 'windowResize',
};



// WEBPACK FOOTER //
// ./scripts/modules/Events.js